import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary';
import { connect } from 'react-redux';
import { Pane } from '../Pane';
import { ObjectStatus } from '../ObjectStatus';
import { useI18n } from '../../locale/I18nContext';
import { useLoadingThemeContext } from './ReportThemeContainer';
import { ThemeProvider } from '@sas/nova-commons/theme';
import { Logon } from './Logon';
const Error = (props) => {
    return (_jsx(Pane, Object.assign({ style: {
            display: 'flex',
            flexShrink: 1,
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center',
        } }, { children: _jsx(ObjectStatus, { mode: "error", text: props.error, style: { flexShrink: 1, margin: '0 1rem' } }) })));
};
export const ReportStoreSuspenseBase = (props) => {
    const localize = useI18n();
    const [loadingTheme] = useLoadingThemeContext();
    if (props.transportError) {
        return (_jsx(ThemeProvider, Object.assign({ currentTheme: loadingTheme }, { children: _jsx(Error, { error: props.transportError }) })));
    }
    else if (props.transportErrorKey) {
        return (_jsx(ThemeProvider, Object.assign({ currentTheme: loadingTheme }, { children: _jsx(Error, { error: localize(props.transportErrorKey) }) })));
    }
    else if (props.url &&
        props.authenticationType &&
        props.connectionStatus === 'credentials-invalid') {
        return (_jsx(ThemeProvider, Object.assign({ currentTheme: loadingTheme }, { children: _jsx(Logon, { authenticationType: props.authenticationType, url: props.url }) })));
    }
    else if (props.fallback && (props.reportLoaded !== true || !props.themeLoaded)) {
        return _jsx(ThemeProvider, Object.assign({ currentTheme: loadingTheme }, { children: props.fallback() }));
    }
    else {
        return (_jsx(ErrorBoundary, Object.assign({ errorMessageKey: { key: 'ReportContainer.renderError.txt' }, style: { height: '100%', width: '100%' }, respondToWASMCrash: true }, { children: props.children })));
    }
};
export const ReportStoreSuspense = connect((state) => {
    return {
        transportError: state.transport.transportError,
        transportErrorKey: state.transport.transportErrorKey,
        connectionStatus: state.transport.connectionStatus,
        reportLoaded: state.transport.reportLoaded,
        themeLoaded: state.transport.themeLoaded,
    };
})(ReportStoreSuspenseBase);
